<template>
  <div class="login-main">
    <div class="loginLogo"></div>
    <h2 class="logo" />
    <div class="login-form">
      <!-- <h1>{{ $t('login.title') }}</h1> -->
      <div class="loginFormTitle"></div>
      <a-tabs v-model:activeKey="activeKey" centered animated>
        <a-tab-pane key="1">
          <a-form
            class="form-content"
            :model="formState"
            name="basic"
            autocomplete="off"
            @finish="login"
          >
            <a-form-item
              name="username"
              :rules="[{ required: true, message: $t('login.rule.name') }]"
            >
              <div style="margin-bottom: 10px">用 户 名</div>
              <a-input size="large" class="inputSty" v-model:value="formState.username">
                <template #prefix>
                  <user-outlined type="user" />
                </template>
              </a-input>
            </a-form-item>

            <a-form-item
              name="password"
              :rules="[{ required: true, message: $t('login.rule.pwd') }]"
            >
              <div style="margin-bottom: 10px">用 户 密 码</div>
              <a-input-password size="large" class="inputSty" v-model:value="formState.password">
                <template #prefix>
                  <lock-outlined />
                </template>
              </a-input-password>
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                size="large"
                style="margin-top: 20px; background-color: #1a277c"
                class="w-100per"
                html-type="submit"
                :loading="loading"
                >{{ $t('button.login') }}</a-button
              >
            </a-form-item>
            <a-form-item>
              <!-- <a-radio-group v-model:value="language" name="radioGroup" @change="changeLanguage">
                <a-radio value="zhCn">中文</a-radio>
                <a-radio value="en">English</a-radio>
              </a-radio-group> -->
            </a-form-item>
          </a-form>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="copyright">
      <p>©copyright 江苏中车数字科技有限公司</p>
      <p>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          备案号：冀ICP备2026042644号-1
        </a>
      </p>
    </div>
  </div>
</template>
<script setup>
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getToken } from '@/utils/token'

const store = useStore()
const router = useRouter()
const language = ref(store.getters.locale)
// 定义表单
const formState = reactive({
  username: '',
  password: ''
})
// 定义loading
const loading = ref(false)
const activeKey = ref('1')

const isLogin = () => {
  if (getToken() && getToken() !== 'null') {
    router.push({ name: 'home' })
  }
}
onMounted(() => {
  isLogin()
})
// 登录
function login() {
  store
    .dispatch('user/login', { ...formState })
    .then((res) => {
      if (!res.success) {
        return
      }
      store.dispatch('system/removeAllTabs')
      store.dispatch('user/updateUserInfo').then((info) => {
        if (info.success) {
          message.success('登录成功')
          router.push({ name: 'home' })
        }
      })
    })
    .finally(() => {
      loading.value = false // 无论登录成功还是失败，都将 loading 状态设置为 false
    })
}
// 切换语言
const changeLanguage = (val) => {
  store.commit('changeLanguage', language.value)
}
</script>
<style lang="less" scoped>
.inputSty {
  border-radius: 5px;
}
:deep(.mainPrefix-tabs-nav) {
  display: none;
}
.form-content {
  height: 150px;
}
#qr {
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-main {
  width: 100vw;
  height: 100vh;

  background-size: auto auto;
  position: relative;
  h1 {
    text-align: center;
    padding: 10px 0;
  }
  .loginLogo {
    width: 540px;
    height: 50px;
    position: absolute;
    left: 30px;
    top: 20px;
    background: url('/public/img/loginLogo.png') center center;
    background-size: 100% 100%;
  }
  .loginFormTitle {
    position: absolute;
    top: 50px;
    width: 465px;
    height: 50px;
    background: url('/public/img/logo.png');
    background-size: 100% 100%;
  }
  .copyright {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 8px 0;
    text-align: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 1.6;
    p {
      margin: 0;
    }
    a {
      color: rgba(0, 0, 0, 0.5);
      text-decoration: none;
      &:hover {
        color: #1a277c;
        text-decoration: underline;
      }
    }
  }
}

.other-login {
  margin: 0;
  display: flex;
  justify-content: center;
  label {
    width: 35px;
    height: 35px;
    background: var(--color-primary);
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      background: rgba(var(--color-primary), 0.9);
      color: #ffffff;
    }
  }
}
.logo {
  width: 236px;
  height: 32px;
  background: url('/public/img/logo.png') center center;
}
.login-form {
  height: 450px;
  width: 520px;
  border-radius: 10px;
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 10px 5px rgba(0, 0, 0, 0.1);
  padding: 20px 25px 40px;
}
@media (min-width: 769px) {
  .logo {
    position: absolute;
    left: 10%;
    top: 10%;
  }
  .login-main {
    background: url('/public/img/bg.png') center center;
    background-size: 100% 100%;
  }
  .login-form {
    right: 10%;
    top: 30%;
  }
}
@media (max-width: 768px) {
  .login-main {
    background: url('/public/img/bg.png') right center;
    background-size: 100% 100%;
  }
  .logo {
    position: absolute;
    left: 50%;
    top: 15%;
    margin-left: -118px;
  }
  .login-form {
    left: 50%;
    top: 25%;
    margin-left: -175px;
  }
}
</style>
